import PropTypes from 'prop-types';
import Twitter from '@mui/icons-material/Twitter';
import { Link, Stack } from '@mui/material';
import LinkedIn from '@mui/icons-material/LinkedIn';
import FacebookSharp from '@mui/icons-material/FacebookSharp';
import MKBox from 'components/MKBox';
import YouTube from '@mui/icons-material/YouTube';

const SocialMedia = ({ color, hoverColor, marginTop, spacing }) => {
  return (
    <MKBox>
      <Stack mt={marginTop} spacing={spacing} direction='row'>
        <Link
          sx={{
            '&:hover': {
              color: { hoverColor },
            },
          }}
          href='https://www.facebook.com/profile.php?id=61563811700898'
          target='_blank'
          rel='noopener'
        >
          <FacebookSharp color={color} fontSize='small' />
        </Link>
        {/*
        <Link
          href='#'
          target='_blank'
          rel='noopener'
          sx={{
            '&:hover': {
              color: hoverColor,
            },
          }}
        >
          <Twitter color={color} fontSize='small' />
        </Link>
        */}
        <Link
          target='_blank'
          rel='noopener'
          href='https://www.linkedin.com/company/chamber-of-suppliers-development-and-diversity/'
          sx={{
            '&:hover': {
              color: hoverColor,
            },
          }}
        >
          <LinkedIn color={color} fontSize='small' />
        </Link>
        {/*
        <Link
          href='#'
          target='_blank'
          rel='noopener'
          sx={{
            '&:hover': {
              color: 'warning',
            },
          }}
        >
          <YouTube color={color} fontSize='small' />
        </Link>
        */}
      </Stack>
    </MKBox>
  );
};

SocialMedia.propTypes = {
  spacing: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired,
  hoverColor: PropTypes.string.isRequired,
  marginTop: PropTypes.number,
};
SocialMedia.defaultProps = {
  spacing: 1,
  color: 'warning',
  hoverColor: 'light',
  marginTop: 0,
};
export default SocialMedia;
